var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 304,
    viewBox: "0 0 449 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.124 613.954C56.7688 623.456 1.58335 566.233 -48.5415 523.229C-95.0091 483.362 -129.719 434.323 -153.173 377.765C-178.467 316.77 -214.091 248.159 -187.71 187.627C-161.513 127.518 -81.7077 118.883 -25.5772 84.996C24.1877 54.9523 64.4387 -6.59665 122.124 0.576754C179.999 7.77384 200.12 81.8647 245.349 118.687C286.741 152.386 343.56 162.89 374.723 206.225C414.196 261.118 468.321 329.963 442.09 392.28C415.41 455.661 316.703 439.18 260.179 478.341C205.825 515.997 187.558 604.44 122.124 613.954Z",
    fill: "#FFF6D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsImage);
export default __webpack_public_path__ + "static/media/stars-image.cccc9d9ea982f0c6fba15199300e624b.svg";
export { ForwardRef as ReactComponent };